import { PromotionType } from '../types/offers';
import formatModelName from './formatModelName';
import { priceFormat } from './formatPrice';

export const parseDigitalLeadsData = (
  offer: PromotionType,
  confirmedZipcode?: string,
  dealerId?: string,
) => {
  const {
    customerDownPayment,
    monthlyPayment,
    term,
    aprRate,
    offerImageUrl,
    creditBonus,
    offerType,
    programShortDescription,
  } = offer;
  const { modelYear, trimline, modelFamily, modelCodeDescription } = offer.offerModelDetail;

  const dataInfo = {
    presetForm: 'contact-dealer',
    dealerId: dealerId ?? null,
    offers: {
      zip: confirmedZipcode ?? null,
      modelName: formatModelName(modelCodeDescription) ?? null,
      modelYear: modelYear ?? null,
      // we currently don't have trimName so we provide trimline
      trimName: trimline ?? null,
      image:
        offerImageUrl ??
        'https://nar.media.audi.com/is/image/audinar/nemo/us/offers/fallbacks/fallback_car_default.png',
      offerType: offerType ?? null,
      offerDetails: {
        customerDownPayment: customerDownPayment ?? null,
        term: term ?? null,
        monthlyPayment: monthlyPayment ? priceFormat(Number(monthlyPayment.toFixed())) : null,
        creditBonus: creditBonus ?? null,
        creditBonusDisclaimer: programShortDescription ?? null,
        aprRate: aprRate ?? null,
        modelFamily: modelFamily ?? null,
      },
    },
  };
  return JSON.stringify(dataInfo);
};
